import React, { useState, useEffect } from 'react';
import './FoundersAchievement.css';
import achievement1 from '../../images/journey/51.jpeg';
import achievement2 from '../../images/journey/11.jpeg';
import achievement3 from '../../images/journey/54.jpeg';
import achievement4 from '../../images/journey/18.jpeg';
import achievement5 from '../../images/journey/2.jpeg';
import achievement6 from '../../images/journey/155.jpeg';
import achievement7 from '../../images/journey/17.jpeg';
import achievement8 from '../../images/journey/50.jpeg';
import achievement9 from '../../images/journey/45.jpeg';

const ACHIEVEMENT_IMAGES = [
  achievement1, achievement2, achievement3, achievement4, achievement5,
  achievement6, achievement7, achievement8, achievement9,
];

const FoundersAchievement = ({ title, subtitle, images }) => {
  const [visible, setVisible] = useState(false);
  const list = images && images.length === 9 ? images : ACHIEVEMENT_IMAGES;

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="founders-achievement" id="founders-achievement">
      <div className="founders-achievement-container">
        <div className="founders-achievement-left">
          <h2 className="founders-achievement-title">
            {title || 'Founders Achievement'}
          </h2>
          <p className="founders-achievement-subtitle">
            {subtitle || 'Impacting 1000+ Trailblazers through learning, mentoring, and career placement, Khyati Mehta is a dynamic Salesforce ecosystem leader driving meaningful change across India and APAC. She is the Founder of WITdreamin — India’s only women-led, community-driven Salesforce conference, and is proudly recognized as India’s first Salesforce podcaster, amplifying real stories and career journeys through her platform. A Salesforce Marketing Champion, Trailblazer Community Forum Ambassador, Trailhead Mentor, Speaker, and Community Leader, Khyati has led multiple national initiatives to democratize Salesforce and AI learning. She serves as the Group Leader of Serviceblazer APAC, has spoken at several Salesforce and international events, and was proudly featured at TDX25 on the big stage screen. Recognized by Salesforce for her impactful nonprofit contributions, Khyati continues to build, mentor, and champion inclusive growth — shaping the next generation of ecosystem leaders across India and beyond.'}
          </p>
        </div>
        <div className="founders-achievement-right">
          <div className="founders-achievement-box">
            {list.map((src, i) => (
              <div
                key={i}
                className={`founders-achievement-item ${visible ? 'founders-achievement-item-visible' : ''}`}
                style={{ animationDelay: `${i * 0.12}s` }}
              >
                <img src={typeof src === 'string' ? src : src.url} alt="" loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoundersAchievement;
